var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ms-checkbox"},[_c('input',_vm._g({attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.value}},_vm.listeners)),_c('span',{staticClass:"checkmark"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],class:[
				{ focused: _vm.focused },
				'mi',
				'mi-18',
				_vm.disabled ? 'mi-checkbox-active-disabled' : 'mi-checkbox-active' ]}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],class:[
				{ focused: _vm.focused },
				'mi',
				'mi-18',
				_vm.disabled
					? 'mi-checkbox-non-active-disabled'
					: 'mi-checkbox-non-active' ]})]),(_vm.title)?_c('span',{staticClass:"ms-checkbox--title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }